if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.engravingRadioName = 'properties[Would you like an engraving (+ €10)]';
        this.engravingTextName = 'properties[Engraving]';
        const getScopedEls = (name) => {
          const formId = this.form?.id;
          const scope = this.closest('product-info') || this.closest('section') || document;
          if (formId) {
            const linked = Array.from(scope.querySelectorAll(`[name="${name}"][form="${formId}"]`));
            if (linked.length) return linked;
          }
          const inForm = this.form ? Array.from(this.form.querySelectorAll(`[name="${name}"]`)) : [];
          return inForm.length ? inForm : Array.from(scope.querySelectorAll(`[name="${name}"]`));
        };
        this.toggleEngravingUI = () => {
          const radios = getScopedEls(this.engravingRadioName);
          const selected = radios.find((radio) => radio.checked);
          const enabled = selected?.value === 'Yes';
          const input = getScopedEls(this.engravingTextName)[0];
          if (!input) return;
          const wrapper = input.closest('.product__options') || input.closest('.field') || input.parentElement;
          if (wrapper) {
            wrapper.hidden = !enabled;
            wrapper.style.setProperty('display', enabled ? '' : 'none', 'important');
          }
          input.disabled = !enabled;
          input.required = enabled;
          if (!enabled) input.value = '';
        };
        getScopedEls(this.engravingRadioName).forEach((radio) => {
          radio.addEventListener('change', this.toggleEngravingUI);
        });
        this.toggleEngravingUI();

      }

      onSubmitHandler(evt) {
        // Prevent native submit + duplicate listeners
        evt.preventDefault();
        evt.stopImmediatePropagation();

        // Multi-click guard (do NOT lock if already disabled)
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.dataset.atcLocked === '1') return;
        this.dataset.atcLocked = '1';

                this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        // Build properties map from formData
        const properties = {};
        for (const [k, v] of formData.entries()) {
          if (k.startsWith('properties[') && k.endsWith(']')) {
            const key = k.slice(11, -1);
            const value = String(v || '').trim();
            if (value) properties[key] = value;
          }
        }

        const engravingEnabled =
        String(properties['Would you like an engraving (+ €10)'] || '').trim().toLowerCase() === 'yes';

        const engravingText = String(properties['Engraving'] || '').trim();

        // If Yes => require text (recommended)
        if (engravingEnabled && !engravingText) {
          this.handleErrorMessage((this.closest('product-info') || this.closest('section'))?.getAttribute('data-engraving-required-message') || 'Please enter your engraving text.');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          this.dataset.atcLocked = '0';
          return;
        }

        // Main item
        const mainVariantId = Number(formData.get('id'));
        const mainQty = Number(formData.get('quantity') || 1);
        
        // Fee variant id from product-info
        const productInfo = this.closest('product-info') || document.querySelector('product-info');
        const feeVariantId = Number(productInfo?.getAttribute('data-engraving-fee-variant-id') || 0);
        const productTitle = productInfo?.getAttribute('data-product-title') || '';
        if (engravingEnabled && !feeVariantId) {
          this.handleErrorMessage(productInfo?.getAttribute('data-engraving-unavailable-message') || 'Engraving is currently unavailable. Please choose No to continue.');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          this.dataset.atcLocked = '0';
          return;
        }


        const items = [
          { id: mainVariantId, quantity: mainQty, properties }
        ];

        // Add fee only if enabled
        if (engravingEnabled && feeVariantId) {
          items.push({
            id: feeVariantId,
            quantity: mainQty, // fee per item
            properties: {
              "Type": "Service",
            }
          });
        }

        // Build payload with sections for cart drawer rendering
        const payload = {
          items,
          sections: this.cart ? this.cart.getSectionsToRender().map((s) => s.id) : undefined,
          sections_url: this.cart ? window.location.pathname : undefined
        };
        if (!payload.sections) delete payload.sections;
        if (!payload.sections_url) delete payload.sections_url;

        // Prepare fetch config as JSON
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(payload);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const quickViewModal = document.getElementById('product-quick-view');
            
            if (quickViewModal) {
              quickViewModal.classList.remove('quick-view-loaded');
              document.body.classList.remove('quickview-open');
            }
            
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.dataset.atcLocked = '0';
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = this.submitButton.hasAttribute('data-preorder') ? 
          window.variantStrings.preOrder : 
          window.variantStrings.addToCart;
          
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
